import React, { Component } from "react";

import {
  Input,
  Wrapper,
  Card,
  Row,
  Copy,
  Button,
  Icon
} from "app/NativeComponents/common";

import SearchTab from "./SearchTab";

class ConversationSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_filter_options: false,
      show_sort_options: false
    };
  }

  renderFilterButton() {
    if (!this.state.show_sort_options) {
      if (this.state.show_filter_options) {
        return (
          <Wrapper style={{ padding: 10 }}>
            <Copy style={{ fontSize: 12 }}>Filter By: </Copy>
          </Wrapper>
        );
      }
      return (
        <Button
          onPress={() => {
            this.setState({
              show_filter_options: !this.state.show_filter_options
            });
          }}
          style={{ padding: 10 }}
        >
          <Row>
            <Copy style={{ fontSize: 12 }}>
              {this.props.conversations_filters.filter_title}
            </Copy>
            <Icon
              style={{ marginLeft: 5 }}
              fa_icon={"sort"}
              size={14}
              color={this.props.colors.light_text_color}
            />
          </Row>
        </Button>
      );
    }
  }

  renderFilterOptions() {
    if (this.state.show_filter_options) {
      return (
        <Wrapper>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.updateConversationFilter({
                filter_type: "all",
                filter_title: "All"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>All</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.updateConversationFilter({
                filter_type: "open",
                filter_title: "Open"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Open</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.updateConversationFilter({
                filter_type: "closed",
                filter_title: "Closed"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Closed</Copy>
          </Button>

          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });
              this.props.updateConversationFilter({
                filter_type: "responded",
                filter_title: "Responded"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Responded</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });
              this.props.updateConversationFilter({
                filter_type: "unread",
                filter_title: "Unread"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Unread</Copy>
          </Button>

          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });
              this.props.updateConversationFilter({
                filter_type: "blocked",
                filter_title: "Blocked"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Blocked</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });

              this.props.updateConversationFilter({
                filter_type: "my_conversations",
                filter_title: "My Conversations"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>My Conversations</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_filter_options: false
              });
              this.props.updateConversationFilter({
                filter_type: "mentioning_me",
                filter_title: "Mentioning Me"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy>Mentioning Me</Copy>
          </Button>
        </Wrapper>
      );
    }
  }

  renderSortOptions() {
    if (this.state.show_sort_options) {
      return (
        <Wrapper>
          <Button
            onPress={() => {
              this.setState({
                show_sort_options: false
              });
              this.props.updateConversationFilter({
                sort_by: "newest",
                sort_by_title: "Sort By: Newest"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy style={{ textAlign: "right" }}>Newest</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_sort_options: false
              });
              this.props.updateConversationFilter({
                sort_by: "oldest",
                sort_by_title: "Sort By: Oldest"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy style={{ textAlign: "right" }}>Oldest</Copy>
          </Button>
          <Button
            onPress={() => {
              this.setState({
                show_sort_options: false
              });

              this.props.updateConversationFilter({
                sort_by: "waiting_longest",
                sort_by_title: "Sort By: Waiting Longest"
              });
            }}
            style={{ padding: 10 }}
          >
            <Copy style={{ textAlign: "right" }}>Waiting Longest</Copy>
          </Button>
        </Wrapper>
      );
    }
  }
  renderSortButton() {
    if (!this.state.show_filter_options) {
      if (this.state.show_sort_options) {
        return (
          <Wrapper style={{ padding: 10, flex: 1 }}>
            <Copy style={{ fontSize: 12, textAlign: "right" }}>Sort By: </Copy>
          </Wrapper>
        );
      }
      return (
        <Button
          onPress={() => {
            this.setState({
              show_sort_options: !this.state.show_filter_options
            });
          }}
          style={{ padding: 10 }}
        >
          <Row>
            <Copy style={{ fontSize: 12 }}>
              {this.props.conversations_filters.sort_by_title}
            </Copy>
            <Icon
              style={{ marginLeft: 5 }}
              fa_icon={"sort"}
              size={14}
              color={this.props.colors.light_text_color}
            />
          </Row>
        </Button>
      );
    }
    return <Wrapper style={{ flex: 1 }} />;
  }

  render() {
    return (
      <Card
        style={{
          marginTop: this.props.isIphoneX
            ? 42
            : this.props.platform == "ios"
            ? 25
            : 12
        }}
      >
        <Row>
          <Button
            onPress={
              this.props.device == "desktop"
                ? () => {
                    this.props.mobileToggleDrawer(
                      !this.props.mobile_toggle_drawer
                    );
                  }
                : () => this.props.toggleDrawer("open")
            }
            style={{
              alignItems: "center",
              justifyContent: "center",
              width: 50
            }}
          >
            <Icon icon="menu" size={26} />
          </Button>
          <Input
            style={{
              borderBottomWidth: 0,
              flex: 1
            }}
            ref="search"
            name="search"
            returnKeyType={"search"}
            blurOnSubmit={true}
            autoCorrect={false}
            autoFocus={false}
            keyboardType="default"
            placeholder={"Search Conversations"}
            onChange={value => {
              this.props.updateConversationFilter({
                search: value
              });
            }}
            value={this.props.conversations_filters.search}
            type="text"
          />

          {this.props.user.team_clearance_level >= 2 &&
          this.props.isMobile == true ? (
            <Button
              onPress={() => {
                this.props.toggleActionSheet("messages_more");
              }}
              style={{
                alignItems: "center",
                justifyContent: "center",
                width: 50
              }}
            >
              <Icon icon="more-vert" size={26} />
            </Button>
          ) : null}
        </Row>
        <Wrapper
          style={{
            backgroundColor: this.props.colors.background_color,
            borderTopWidth: 1,
            borderTopColor: this.props.colors.border_color,
            borderTopStyle: "solid",
            padding: 5
          }}
        >
          <Row
            style={{
              justifyContent: "space-between"
            }}
          >
            {this.renderFilterButton()}
            {this.renderSortButton()}
          </Row>

          {this.renderFilterOptions()}
          {this.renderSortOptions()}
        </Wrapper>
      </Card>
    );
  }
}

export default ConversationSearch;
